import { gql } from 'apollo-angular';

export const GET_COMPETITIONS = gql`
  query Competitions($filter: CompetitionInput) {
    competitions(filter: $filter) {
      id
      name
      type
      startDate
      endDate
      level
      region
      seasonId
    }
  }
`;

export const GET_COMPETITION_INSCRIPTIONS = gql`
  query GetCompetitionInscriptions($filter: CompetitionInscriptionFilterInput) {
    competitionInscriptions(filter: $filter) {
      competitionId
      seasonId
      teamId
      isDefault
    }
  }
`;

export const GET_CLASSIFICATION_SUMMARY = gql`
  query CompetitionClassification($competitionId: Int!, $seasonId: Int!) {
    expectedPointsByTeam: teamCompetitionKpis(
      filter: { kpiMasterId: [3], competitionId: [$competitionId], seasonId: [$seasonId] }
    ) {
      value
      teamId
    }
    xPtsChangeByTeam: teamCompetitionKpis(
      filter: { kpiMasterId: [1005], competitionId: [$competitionId], seasonId: [$seasonId] }
    ) {
      value
      teamId
    }
    teams(filter: {}) {
      id
      name
    }
  }
`;
